import React from 'react';
import { connect } from 'react-redux';

import GroupMembersComponent from './GroupMembersComponent';

import {
  teamFeedActions,
  teamFeedOperations,
  teamFeedSelectors,
} from '../../duck';

const mapStateToProps = (state) => {
  const {
    teamFeedReducer,
    setupReducer,
    appReducer,
    locationReducer,
  } = state;

  return {
    activeSidePane: teamFeedSelectors.getActiveSidePane(teamFeedReducer),
    activePost: teamFeedSelectors.getActivePost(teamFeedReducer),
    activeChannel: teamFeedSelectors.getActiveChannel(state),
    activeChannelRefreshToken: teamFeedSelectors.getActiveChannelRefreshToken(state),
    active: teamFeedReducer.active,
    locationId: locationReducer.location_code,
    locations: locationReducer.locations,
    allUsers: appReducer.allUsers.users,
    managers: appReducer.managers.users,
    associates: appReducer.associates.users,
    onlineUsers: appReducer.onlineUsers.users,
    receipts: teamFeedReducer.readReceipts,
  };
};

const mapDispatchToProps = (dispatch) => {
  const resetActiveSidePane = () => {
    dispatch(teamFeedActions.updateActiveSidePane(''));
  };

  const setActiveSidePane = (pane) => {
    dispatch(teamFeedActions.updateActiveSidePane(pane));
  };

  const addRemoveChannelUsers = (selectedUsers, channelId, mode, subscriptionId) => {
    if (mode === 'add') {
      const promises = selectedUsers.map(user =>
        dispatch(teamFeedOperations.addUserToChannel(user, channelId, subscriptionId))
      );
      console.log('Promises:', promises);
      Promise.all(promises)
        .then(() => {
          console.log('All users added to the channel');
          // Optionally dispatch something to refresh UI
          dispatch(teamFeedActions.updateActiveChannelRefresh());
        })
        .catch((error) => {
          console.error('Error adding users:', error);
        });
    } else if (mode === 'remove') {
      const promises = selectedUsers.map(user =>
        dispatch(teamFeedOperations.removeUserFromChannel(user, channelId, subscriptionId))
      );

      Promise.all(promises)
        .then(() => {
          console.log('All users removed from the channel');
          // Optionally dispatch something to refresh UI
          dispatch(teamFeedActions.updateActiveChannelRefresh());
        })
        .catch((error) => {
          console.error('Error removing users:', error);
        });
    }
  }

  return {
    resetActiveSidePane,
    setActiveSidePane,
    addRemoveChannelUsers
  }
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupMembersComponent);
